module.exports = __webpack_public_path__ + "img/32.0c60240b.png";